import { Grid2, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const Address = ({ inside_spacing, disabled, values, index, commonProps }) => {
    return (
        (<Grid2 container spacing={inside_spacing}>
            <Grid2
                size={{
                    xs: 12,
                    lg: 12
                }}>
                <Typography>Address</Typography>
            </Grid2>
            <Grid2
                size={{
                    xs: 8,
                    lg: 8
                }}>
                <TextField
                    {...commonProps("addressList[" + index + "].address1")}
                    value={values.address1}
                    disabled={disabled}
                    placeholder="Full Address"
                />
            </Grid2>
            <Grid2
                size={{
                    xs: 4,
                    lg: 4
                }}>
                <TextField variant="outlined" fullWidth disabled={disabled} />
            </Grid2>
            <Grid2 size={6}>
                <TextField
                    {...commonProps("addressList[" + index + "].city")}
                    value={values.city}
                    disabled={disabled}
                    placeholder="City"
                />
            </Grid2>
            <Grid2
                size={{
                    xs: 3,
                    md: 3
                }}>
                <TextField
                    {...commonProps("addressList[" + index + "].state")}
                    value={values.state}
                    disabled={disabled}
                    placeholder="State"
                />
            </Grid2>
            <Grid2
                size={{
                    xs: 3,
                    md: 3
                }}>
                <TextField
                    {...commonProps("addressList[" + index + "].zip")}
                    value={values.zip}
                    disabled={disabled}
                    placeholder="Zip"
                />
            </Grid2>
        </Grid2>)
    );
};

Address.propTypes = {
    inside_spacing: PropTypes.number,
    disabled: PropTypes.bool,
    values: PropTypes.object,
    index: PropTypes.number,
    commonProps: PropTypes.func,
};

export default Address;
